import { environment } from '../config/cabinet-environment';

/**
 * Visibility rule for the license administration surfaces.
 *
 * | build              | visible |
 * |--------------------|---------|
 * | local (ng serve)   | yes     |
 * | cloud dev          | yes     |
 * | cloud stage / prod | no      |
 *
 * Gates on ENV_LABEL rather than PRODUCTION: stage is also `PRODUCTION: false`,
 * so the usual !PRODUCTION check would expose this there too.
 *
 * The !PRODUCTION term is not redundant with the label. Desktop hardcodes
 * `production: true` precisely so features gate off (see desktop-shell main.ts),
 * but passes no envLabel -- and the shim defaults ENV_LABEL to 'DEV'. A label
 * check alone therefore reads as true on desktop. Desktop registers neither
 * these routes nor this sidebar today, so nothing is exposed, but the rule
 * should not depend on that staying true.
 */
export function canUseLicenseAdmin(): boolean {
  return !environment.PRODUCTION && (environment.ENV_LABEL === 'DEV' || environment.ENV_LABEL === 'LOCAL');
}
